var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReviewBlockTablet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 393,
    height: 194,
    viewBox: "0 0 393 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.7185 11.679H342.229L388.38 68.5235V163.975L367.586 189.593H10.1293",
    stroke: "#1DA88F",
    strokeWidth: 0.85,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1569 6.64893H337.679L383.818 63.4935V158.945L363.024 184.563H5.57887",
    stroke: "#1DA88F",
    strokeWidth: 0.85,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.606 9H345.902L392.001 65.8764V161.381L371.225 187H14.0926",
    stroke: "#1DA88F",
    strokeWidth: 0.85,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3222 6H344.611L390.72 64.1596V161.793L369.945 188H12.8114",
    stroke: "#1DA88F",
    strokeWidth: 0.89,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2316 1.00024H339.743L385.882 62.2154V164.978L365.088 192.562H7.64235",
    stroke: "#1DA88F",
    strokeWidth: 0.89,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6357 4H336.925L383.033 63.428V163.217L362.258 190H5.12483",
    stroke: "#05F2C7",
    strokeWidth: 0.85,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5778 6.64868H332.1L378.239 63.4932V158.944L357.445 184.563H-0.000227749",
    stroke: "#05F2C7",
    strokeWidth: 0.85,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4942 6H340.622L386.877 63.835V160.949L366.031 187H7.68754",
    stroke: "#05F2C7",
    strokeWidth: 0.85,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M92.917 6H338.206L384.314 63.84V160.937L363.539 187H6.40608",
    stroke: "#05F2C7",
    strokeWidth: 0.89,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6535 1H334.164L380.304 62.2151V164.978L359.51 192.562H2.06423",
    stroke: "#05F2C7",
    strokeWidth: 0.89,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewBlockTablet);
export default __webpack_public_path__ + "static/media/review_block-tablet.1c6d9a247b857b1a32293171ad91042b.svg";
export { ForwardRef as ReactComponent };